export const METRIC_SIGNALS = new Set([
  'oops_page_shown',
  'app_oops_page_shown',
]);
